/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 30.06.2016
 */
'use strict';

import { amdRequire } from 'plugin/liferay-widgets-react-web';

import L from 'external/leaflet';

// Source projection WGS84
const SOURCE_PROJ = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs';
// Destination projection EPSG:31467
const DEST_PROJ = '+proj=utm +zone=32 +ellps=GRS80 +units=m +no_defs';

export default class HWRMPlugin {

    constructor(props, config){
        this.config = config;
        this.props = props;

        this.active = false;

        this.toggleTextLabelControl = this.toggleTextLabelControl.bind(this);
    }

    init(map, o){
        this._map = map;
        this.hwrmControlTemplate = L.Control.extend({
            options: {
                position: 'topleft'
            },

            onAdd: (map) => {
                this.container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
                this.icon = L.DomUtil.create('span', 'icon icon-map-crosshairs-waves', this.container);
                this.container.setAttribute('title', 'Hochwasserrisikomanagement-Abfrage (HWRM)');
                this.container.setAttribute('role', 'button');

                L.DomEvent.on(this.container, 'click', this.toggleTextLabelControl, this);
                return this.container;

            }
        });
        this.hwrmControl = new this.hwrmControlTemplate();
        map.addControl(this.hwrmControl);

        map.on('click', this.onHwrmClick.bind(this));

        setTimeout(() => amdRequire(['proj4'], () => {
        }), 1500);
    }

    toggleTextLabelControl(e){
        if (e) {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
        }

        if (this.active) {
            this.active = false;
             this._map.blockingControlActive = false;
            this.container.classList.remove('active');
            return;
        }

        if (this._map.blockingControlActive) {
            return;
        }

        this.active = true;
        this._map.blockingControlActive = true;
        this.container.classList.add('active');
    }

    onHwrmClick(e){
        if (this.active) {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            const HWRMwindow = window.open('', '_blank');
            HWRMwindow.blur();
            amdRequire(['proj4'], (proj4) => {
                const lat = e.latlng.lat;
                const lng = e.latlng.lng;
                const transformedCoordinates = proj4(SOURCE_PROJ, DEST_PROJ, [lng, lat]);
                const easting = transformedCoordinates[0];
                const northing = transformedCoordinates[1];

                HWRMwindow.location.href = `http://rips-dienste.lubw.baden-wuerttemberg.de/rips/ripsservices/apps/hwrm/Abfrage.aspx?x=${easting}&y=${northing}`;
                HWRMwindow.focus();

                this.toggleTextLabelControl(e.originalEvent);
            });
        }
    }

}



// WEBPACK FOOTER //
// ./js/plugins/HWRMPlugin.js